import Button from '@components/v2/ui/Button/Button';
import Typography from '@components/v2/ui/Typography/Typography';
import LangEnum from '../../../../../../lang/LangEnum';
import useSharedEntitystore from '../../../../../../stores/SharedEntities/sharedEntities.store';
import { useTranslation } from '../../../../../translation/TranslationContext';
import { getOrderSummaryActionButtonStyles } from './orderSummaryActions.styles';

const LoginButton = () => {
  const handleChangeIsOpenLoginModal = useSharedEntitystore(
    (state) => state.handleChangeIsOpenLoginModal,
  );
  const { translate } = useTranslation();

  return (
    <Button
      fullWidth
      variant="contained"
      color="primary"
      size="large"
      sx={getOrderSummaryActionButtonStyles}
      onClick={() => handleChangeIsOpenLoginModal(true)}
    >
      <Typography noWrap>{translate(LangEnum.GLOBAL_LOGIN)}</Typography>
    </Button>
  );
};

export default LoginButton;
